import { AudioManager } from "./AudioManager";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import { SplashScene } from "./scenes/splash-scene/SplashScene";
declare var gamezop: any;
export class Game extends Phaser.Game {

    public static currentInstance: Game;

    private onBlurTime: number;

    constructor(config: Phaser.Types.Core.GameConfig) {
        
        super(config);
              
        Game.currentInstance = this;

        if (!this.device.os.desktop) {
          // console.log("Added fullscreen change listener");
          // document.addEventListener("fullscreenchange", this.onFullScreen);
            // this.scale.on("enterfullscreen", this.onFullScreen, this);
        }
    }

    public onBlur(): void {

        this.onBlurTime = new Date().getTime();

        /* if (AudioManager.sound) {
            AudioManager.sound.mute(true);
        } */
        if (gamezop.mute) {
          gamezop.mute();
        }
        
        super.onBlur();
    }

    public onFocus(): void {

       /*  if (AudioManager.sound) {
            AudioManager.sound.mute(GameVars.gameData.muted);
        } */
        if (gamezop.mute) {
          gamezop.unmute();
        }

        const now = new Date().getTime();
        const deltaTime = Math.floor((now - this.onBlurTime) / 1000);

        if (GameVars.playingAgainstBot) {
            GameVars.time += deltaTime;
        }

        super.onFocus();
    }

    public launchIntoFullscreen(element: any): void {

        if (GameConstants.DISABLE_FULLSCREEN) {
            return;
        }

        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }

    private onFullScreen(): void {

        console.warn("<> on full screen <> ");

        GameVars.currentScene.time.delayedCall(65, function(): void {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            GameVars.aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / GameVars.aspectRatio;

            if (GameVars.currentScene.scene.key === "SplashScene") {
                SplashScene.currentInstance.onFullScreen();
            } else if (GameVars.currentScene.scene.key === "BoardScene") {
                BoardScene.currentInstance.onFullScreen();
            }
            
        }, [], this);
    }
}
